/* V56: единственото ново поведение на филтрите е desktop сгъване.
   Shopify/Sheen продължава да обработва URL, стойности, сортиране и AJAX. */
document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-sxt-filter-toggle]');
  if (!button) return;
  const section = button.closest('.shopify-section');
  const collapsed = section.classList.toggle('sxt-filters-collapsed');
  button.setAttribute('aria-expanded', String(!collapsed));
});
